import React, { useContext } from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import { ChevronRight, ChevronLeft } from 'react-feather';

import { PageContext } from '../PageContext';
import { v4tov3base } from '../../lib/mapV4toV3';
import { addTrailingSlash } from '../../lib/helpers';

import * as styles from './SpeechBubble.module.scss';

type SpeechBubbleProps = {
  variant?: 'brand-a-light' | 'brand-b' | 'brand-c' | 'brand-c-reverse';
  speechBubbleText: string;
  className?: string;
  url?: string;
  linkText?: string;
  isReverse?: boolean;
  asParagraph?: boolean;
};

const SpeechBubble = ({
  className,
  speechBubbleText,
  variant = 'brand-c',
  url,
  linkText,
  isReverse,
  asParagraph
}: SpeechBubbleProps) => {
  const { websiteLocale } = useContext(PageContext);
  const { hasRightToLeftLanguage } = v4tov3base({ ...websiteLocale.attributes });

  return (
    <div
      data-testid="speechBubble"
      className={classnames(
        variant === 'brand-b' ? styles.redWrapper : '',
        variant === 'brand-b' ? styles.redTail : '',
        variant === 'brand-c' ? styles.blueWrapper : '',
        variant === 'brand-c' ? styles.blueTail : '',
        variant === 'brand-c' && isReverse ? styles.blueTailReverse : '',
        variant === 'brand-a-light' ? styles.lightBlueWrapper : '',
        variant === 'brand-a-light' ? styles.lightBlueTail : '',
        variant === 'brand-a-light' && isReverse ? styles.reverse : '',
        className,
      )}
    >
      {asParagraph ?
        <p className="title is-4 has-text-weight-800 mb-1">{speechBubbleText}</p>
        : 
        <h4 className="title is-4 has-text-weight-800 mb-1">{speechBubbleText}</h4>
      }
      {linkText && (
        <div>
          <Link to={url ?? ''}>
            <span className="text-3 brand-a">{linkText ?? ''}</span>
          </Link>
          {hasRightToLeftLanguage ? (
            <ChevronLeft size={12} className="black-3 ml-1 has-text-weight-bold" />
          ) : (
            <ChevronRight size={12} className="black-3 ml-1 has-text-weight-bold" />
          )}
        </div>
      )}
    </div>
  );
};

export default SpeechBubble;
